// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"53961441","699":"09a5eeee","727":"8de6ade0","778":"1e257dae","918":"b7c3f630","961":"0a61ff26"}[chunkId] + ".chunk.css";
};